<app-question-card>
  <p question>What is the overall condition of your home.</p>
  <div class="form-field" input-options>
    <div class="radio-option-arrow condition" *ngFor="let option of options">
      <input
        type="radio"
        [id]="conditionName + option.name"
        [name]="conditionName"
        [value]="option.value"
        [(ngModel)]="homeConditionLevel"
        (click)="submit(option)"
      />
      <label [for]="conditionName + option.name">
        <img [src]="'/assets/images/area-condition/light/' + option.image + '.svg'" [alt]="'condition-' + option.image" />
        <div>
          {{ option.name }}
          <p class="mt-1">{{ option.description }}</p>
        </div>
        <app-icon class="ml-auto" color="var(--color-primary)" fontWeight="100" fontSize="32">right</app-icon>
      </label>
    </div>
  </div>
  <p class="chat-answer" answer>{{HomeConditionLevelLabel[homeConditionLevel!]}}</p>
</app-question-card>
